import { environment } from 'src/environment'
import { Component, OnInit } from '@angular/core';
import { IdealPayComponent } from '../ideal-pay/ideal-pay.component';

@Component({
  selector: 'app-stripe-info',
  templateUrl: './stripe-info.component.html',
  styleUrls: ['./stripe-info.component.scss'],
  standalone: true,
  imports: []
})
export class StripeInfoComponent implements OnInit {

  skinName = environment.skinName;
  constructor() { }

  ngOnInit(): void {
  }

}
